import { createSlice } from '@reduxjs/toolkit';
import type { DbUser } from '@hub/common';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { User } from 'features/auth/types/User';

type AuthState = {
  // Current user, if available equals to being signed in
  user: User | undefined;
};

const initialState: AuthState = {
  user: undefined,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState: (
      state,
      action: PayloadAction<{
        user?: User | undefined;
      }>
    ) => {
      const { user } = action.payload;
      if (user !== undefined) {
        state.user = user;
      }
    },
    setUserData: (state, action: PayloadAction<DbUser | undefined>) => {
      if (action.payload && state.user) {
        if (action.payload.language) {
          state.user.language = action.payload.language;
        }
        if (action.payload.participantId) {
          state.user.participantId = action.payload.participantId;
        }
      }
    },
  },
});

export const { setAuthState, setUserData } = authSlice.actions;
export const authReducer = authSlice.reducer;
